export const parseDogNode = ({
	dogData,
}: Queries.DogQueryQuery): DogsTrust.DogData => ({
	apiKey: dogData.apiKey,
	key: dogData.field_dog_key,
	id: dogData.id,
	name: dogData.title,
	url: dogData.path.alias,
	created: dogData.field_dog_external_creation_date,
	isPublished: dogData.status,
	gender: dogData.field_dog_gender,
	dob: dogData.field_dob,
	breed: dogData.relationships.field_dog_breed?.name,
	crossbreed: dogData.relationships.field_crossbreed?.name,
	isCrossBreed: dogData.field_iscrossbreed,
	frontEndBreedName: dogData.frontEndBreedName,
	size: dogData.relationships.field_dog_dog_size?.name,
	centreName: dogData.thisDogsCentre?.title,
	centreCode: dogData.relationships.field_dog_location?.name,
	status: dogData.relationships.field_dog_status?.name,
	liveWithCats: dogData.field_dog_with_cats,
	liveWithDogs: dogData.field_dog_with_dogs,
	liveWithPreschool: dogData.field_dog_with_preschool,
	liveWithPrimary: dogData.field_dog_with_primary,
	liveWithSecondary: dogData.field_dog_with_secondary,
	needsMedicalCare: dogData.field_needs_medical_care,
	media: JSON.parse(JSON.stringify(dogData.media)),
	imgUrl: dogData.media?.images?.[0]?.src,
	info: dogData.field_info,
	likesDislikes: dogData.field_likesdislikes,
	homeRequirements: dogData.field_typeofhomerequired,
	isReserved: !!dogData.field_isreserved,
	isHomeFromHome: !!dogData.field_ishomefromhome,
	isUnderdog: !!dogData.field_isunderdog,

	// This is only on the IE site and will only appear in Queries.DogQueryQuery if the gatsby-types has been built from the IE site so
	microchip:
		"field_microchip" in dogData && (dogData.field_microchip as string),

	location: {
		address: "",
		latitude: Number.parseFloat(dogData.thisDogsCentre?.field_latitude),
		longitude: Number.parseFloat(dogData.thisDogsCentre?.field_longitude),
	},
});

export const parseSponsorDogNode = (dog: Queries.SponsorDogDataFragment) => ({
	apiKey: dog.apiKey,
	id: dog.fundCode,
	fundCode: dog.fundCode,
	profileUrl: dog.profileUrl,
	imagePath: dog.imagePath,
	name: dog.title,
	breed: dog.relationships.field_breed?.[0]?.name,
	gender: dog.field_sex,
	centreName: dog.rehomingCentre.title,
	galleryItems: [
		dog.relationships.field_featured_image,
		...dog.relationships.field_gallery_of_images_or_video,
	]
		.filter((media) => media.__typename === "media__image")
		.map((image: Queries.MediaImageOrVideoData_media__image_Fragment) => ({
			type: "image",
			src: image.field_media_image.uri,
			alt: image.field_media_image.alt,
		})),
	url: dog.path.alias,
});
